"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_STATUS = void 0;
var HTTP_STATUS;
(function (HTTP_STATUS) {
    HTTP_STATUS[HTTP_STATUS["SUCCESS"] = 200] = "SUCCESS";
    HTTP_STATUS[HTTP_STATUS["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTP_STATUS[HTTP_STATUS["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTP_STATUS[HTTP_STATUS["FORBIDDEN_AUTHORISER"] = 243] = "FORBIDDEN_AUTHORISER";
    HTTP_STATUS[HTTP_STATUS["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
})(HTTP_STATUS || (exports.HTTP_STATUS = HTTP_STATUS = {}));
//# sourceMappingURL=constants.js.map